<section class="internal-video-admin">
  <header class="panel-header">
    <div>
      <h3>Vídeos IA</h3>
      <p>Listado interno para relanzar entrenamiento IA sobre vídeos recientes.</p>
    </div>
    <div class="summary-row">
      <span class="chip">Total: {{ total }}</span>
      <span class="chip">Página: {{ currentPage }}</span>
      <span class="chip">{{ pageLabel }}</span>
    </div>
  </header>

  <div class="toolbar">
    <label class="search-field">
      <span>Buscar</span>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Título o video_id"
        (keyup.enter)="searchVideos()"
      />
    </label>

    <div class="toolbar-actions">
      <button class="secondary" (click)="loadVideos()" [disabled]="isLoading">Actualizar</button>
      <button (click)="searchVideos()" [disabled]="isLoading">Buscar</button>
    </div>
  </div>

  @if (feedbackMessage) {
    <p class="feedback">{{ feedbackMessage }}</p>
  }

  <div class="list-shell" [class.loading]="isLoading">
    @if (videos.length === 0 && !isLoading) {
      <div class="empty-state">No hay vídeos para el filtro actual.</div>
    } @else {
      <div class="video-list">
        @for (video of videos; track video.video_id) {
          <article class="video-card">
            <div class="video-copy">
              <div class="video-head">
                <h4>{{ video.title }}</h4>
                <span class="video-date">
                  {{ (video.uploaded_at || '') | date:'dd/MM/yyyy HH:mm' }}
                </span>
              </div>
              <p class="video-id">{{ video.video_id }}</p>
            </div>

            <button
              class="primary-action"
              (click)="onRelaunchVideo(video)"
              [disabled]="isRelaunching(video.video_id)"
            >
              {{ isRelaunching(video.video_id) ? 'Relanzando...' : 'Relaunch IA' }}
            </button>
          </article>
        }
      </div>
    }
  </div>

  <footer class="pagination-row">
    <button class="secondary" (click)="goToPreviousPage()" [disabled]="!hasPreviousPage || isLoading">
      Anterior
    </button>
    <span class="page-status">{{ pageLabel }}</span>
    <button (click)="goToNextPage()" [disabled]="!hasNextPage || isLoading">
      Siguiente
    </button>
  </footer>
</section>
